import script from "./InstallationPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./InstallationPanel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__